
import { useState } from "react";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { Input } from 'antd';
import Swal from "sweetalert2";
import { DeleteInvoice } from "../../../Service/Service.billing";

// ANULACION-FISCAL-64: anular una factura YA EMITIDA a Contifico/SRI es una
// accion de otra categoria que anular un documento que nunca salio -- quema el
// correlativo de forma irreversible y presupone que la reversion fiscal ante
// el SRI ya se hizo FUERA de este sistema (aqui la anulacion es 100% local).
// El aviso se muestra ANTES de escribir el motivo, no despues del error:
// enterarse de que se quemo un numero cuando ya esta hecho no sirve de nada.
// El mismo predicado que usa el backend para decidir (`id_contifico` no
// vacio), nunca uno propio que pudiera divergir.
function EliminarFactura({ data }) {
    const { show, handleClose, invoice, handleConfirmDelete } = data;

    const esFiscal = Boolean(invoice?.id_contifico);

    const { TextArea } = Input;

    const [loading, setLoading] = useState(false);
    const [motivo, setMotivo] = useState("");

    const handleMotivoChange = (event) => {
        setMotivo(event.target.value);
    };

    const handleDelete = async () => {

        try {
            setLoading(true);

            const response = await DeleteInvoice(invoice.idfactura, {motivo});
            if (!response.success) {
                throw new Error(response.message);
            }

            handleClose();
            handleConfirmDelete();
            setMotivo("");

            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                showConfirmButton: true,
            });    
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message,
            });  
            
        } finally {
            setLoading(false);
        }

    }

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="md">
            <Modal.Header closeButton>
                ¿Eliminar Factura {invoice.num_documento} id: {invoice.idfactura}?
            </Modal.Header>

            <Modal.Body>

                {esFiscal && (
                    <Row className="mb-3">
                        <Col>
                            <div className="alert alert-warning mb-0 py-2 px-3" role="alert" data-testid="anular-aviso-fiscal">
                                <strong>Esta factura ya fue emitida al SRI.</strong>
                                <div className="small mt-1">
                                    Anúlela aquí sólo si ya realizó la anulación fiscal ante el SRI.
                                    El número <strong>{invoice.num_documento}</strong> quedará quemado: no se
                                    reutilizará y la siguiente factura tomará el número siguiente.
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}

                <Row className="d-flex justify-content-center">
                    <Col className="text-center">

                        <div className="w-auto">
                            <TextArea rows={3}
                                placeholder="Ingrese motivo, max. 250 caracteres"
                                value={motivo}
                                onChange={handleMotivoChange}
                                maxLength={250} />
                        </div>

                    </Col>

                </Row>


            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-danger m-1 btn-sm" disabled={loading || !motivo} onClick={handleDelete}>
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            {" "}Por favor espere...
                        </>
                    ) : "Eliminar"}
                </button>
            </Modal.Footer>

        </Modal>
    )
}

export default EliminarFactura;